/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
import React from 'react';

export default function HtmlBlock({ html }) {
  if (!html) {
    return null;
  }

  return <section className="fsf-copy" dangerouslySetInnerHTML={{ __html: html }} />;
}
